import { Controller, useForm } from "react-hook-form";
import { useState } from "react";
import { UserActions } from "../../pages/user_management/user_actions_enum";
import { CustomTextField, PasswordField } from "./form_fields";
import { Box, Button, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NDA from "./nda";
const CustomUserForm = ({ editUserData, handleFieldValueChanges, actionType, onSubmit, isLoading, signedNDA }) => {
  const { control, formState, getValues } = useForm({ mode: "onChange" });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // VALIDATION RULES --------------------------------------------------------------------------------------------------------------
  const MIN_PASSWORD_LENGTH = 8;
  const NAME_MIN_LENGTH = 3;
  const NAME_MAX_LENGTH = 200;

  const usernameValidationRules = {
    // We will check if the username is valid when the call is made...
    required: true,
    minLength: {
      value: NAME_MIN_LENGTH,
      message: "Minimum length is " + NAME_MIN_LENGTH,
    },
    maxLength: {
      value: NAME_MAX_LENGTH,
      message: "Max length is " + NAME_MAX_LENGTH,
    },
  };

  const PasswordValidationRules = {
    required: true,
    minLength: {
      value: MIN_PASSWORD_LENGTH,
      message: `Password should contain at least ${MIN_PASSWORD_LENGTH} characters`,
    },
  };

  const ConfirmPasswordValidationRules = {
    required: true,
    validate: {
      confirmPassword: (value) => {
        return value === getValues("password") || "Passwords do not match";
      },
    },
  };
  // ------------------------------------------------------------------------------------------------------------------------------

  // FORM FIELDS ------------------------------------------------------------------------------------------------------------------
  const usernameField = (
    <Controller
      control={control}
      name="username"
      defaultValue=""
      rules={usernameValidationRules}
      render={({ field, fieldState: { error } }) => (
        <CustomTextField
          {...field}
          fullWidth={true}
          label="Username"
          size="small"
          helperText={formState?.errors?.username?.message}
          error={error !== undefined}
          autoComplete="username"
          value={editUserData.username ?? ""}
          onChange={(e) => {
            field.onChange(e);
            handleFieldValueChanges(e);
          }}
        />
      )}
    />
  );

  const passwordField = (
    <Controller
      control={control}
      name="password"
      defaultValue=""
      rules={PasswordValidationRules}
      render={({ field, fieldState: { error } }) => (
        <PasswordField
          {...field}
          fullWidth={true}
          label="Password"
          size="small"
          helperText={formState?.errors?.password?.message}
          error={error !== undefined}
          onChange={(e) => {
            field.onChange(e);
            handleFieldValueChanges(e);
          }}
          showPassword={showPassword}
          toggleShowPassword={() => setShowPassword(!showPassword)}
        />
      )}
    />
  );

  const confirmPasswordField = (
    <Controller
      control={control}
      name="confirmPassword"
      defaultValue=""
      rules={ConfirmPasswordValidationRules}
      render={({ field, fieldState: { error } }) => (
        <PasswordField
          {...field}
          fullWidth={true}
          label="ConfirmPassword"
          size="small"
          helperText={formState?.errors?.confirmPassword?.message}
          error={error !== undefined}
          onChange={(e) => {
            field.onChange(e);
            handleFieldValueChanges(e);
          }}
          showPassword={showConfirmPassword}
          toggleShowPassword={() => setShowPassword(!showConfirmPassword)}
        />
      )}
    />
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [NDAAccepted, setNDAAccepted] = useState(signedNDA);

  const signNDAText = (
    <>
      {signedNDA === 1 ? (
        ""
      ) : (
        <Box>
          {NDAAccepted ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <CheckCircleIcon fontSize="xs" style={{ color: "green" }} />
              <p style={{ marginLeft: 8, marginBottom: 0 }}>
                Gebruikersovereenkomst geaccepteerd (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenDialog(true);
                  }}
                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                >
                  Gebruikersovereenkomst
                </a>
                ).
              </p>
            </Box>
          ) : (
            <p>
              Klik{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenDialog(true);
                }}
                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
              >
                hier
              </a>{" "}
              om de gebruikersovereenkomst te aanvaarden/afwijzen.
            </p>
          )}

          <NDA open={openDialog} onClose={() => setOpenDialog(false)} onAgree={(value) => setNDAAccepted(value)} />
        </Box>
      )}
    </>
  );

  // ------------------------------------------------------------------------------------------------------------------------------
  const renderFields = (actionType) => {
    // Return fields based on actionType
    switch (actionType.action) {
      case UserActions.RESET_PASSWORD_TEMP_LINK.action:
        return (
          <>
            {passwordField}
            {confirmPasswordField}
            {signNDAText}
          </>
        );
      case UserActions.REQUEST_RESET_TEMP_LINK.action:
        return <>{usernameField}</>;
      default:
        return null;
    }
  };

  return (
    <>
      {renderFields(actionType)}
      {!isLoading ? (
        <Box sx={{ marginTop: 2 }}>
          <Button
            onClick={onSubmit}
            variant="contained"
            color="primary"
            disabled={
              isLoading ||
              formState?.isValid === false ||
              (actionType.action === UserActions.RESET_PASSWORD_TEMP_LINK.action ? !NDAAccepted : false)
            }
            sx={{ display: "flex", margin: "auto" }}
          >
            Submit
          </Button>
        </Box>
      ) : (
        <CircularProgress size={24} />
      )}
    </>
  );
};

export default CustomUserForm;
